import React, { useRef, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import {
  Box,
  Button,
  Tooltip,
  Grid
} from "@material-ui/core";

import FormInput from "../Controls/Input";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers";
import { FormProvider, useForm } from "react-hook-form";
import useAuth from "../hooks/Auth";
import Roles from "../constants/Roles";
import Alert from "../components/Alert";
import FormDatePicker from "../Controls/DatePicker";
import FormAutocomplete from "../Controls/Autocomplete";
import DnerhsApi from "../api/DnerhsApi";
import ResponseUtils from "../utils/ResponseUtils";
import FormSelect from "../Controls/Select";
import ReCAPTCHA from "react-google-recaptcha"; 
import AdjuntosDialog from "./AdjuntosDialog";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  button: {
    margin: theme.spacing(1),
  },
  styleItem: {
    height: "100%",
    width: "100%",
    overflow: "auto",
  },
  field: {
    margin: theme.spacing(),
  }
}));
const validationSchema = yup.object().shape({
  institucion: yup.string().required("El campo institucion es requerido"),
  sede: yup.string().required("El campo sede es requerido"),
  telefono: yup.string().required("El campo telefono es requerido"),
  email: yup.string().required("El campo email es requerido"),
  direccion: yup.string().required("El campo direccion es requerido"),
  departamento: yup.string().required("El campo departamento es requerido"),
  ciudad: yup.string().required("El campo ciudad es requerido"),
  ley: yup.string().required("El campo ley es requerido"),
  tipoInstitucion: yup.string().required("El campo tipo Institucion es requerido"),
  logotipo: yup.string().required("El campo tipo Institucion es requerido"),
}); 
export default function FullScreenDialog(props) {
  const classes = useStyles();
  const methods = useForm({
    resolver: yupResolver(validationSchema)
  });
  //const methods = useForm({});
  const { handleSubmit, setValue, reset, errors , setValues, getValues} = methods;
  const { hasRole } = useAuth();  
  const methods2 = useForm({
    shouldUnregister: false,
    //  resolver: yupResolver(validationSchema),
  });
  const {  handleSubmit: handleSubmit2,   errors: errors2,  reset: reset2, setValue:getValues2, getValues:getValues3 } = methods2;
 const [timeDesde, setTimeDesde] = useState("00:00");
 const [timeHasta, setTimeHasta] = useState("00:00");
 const [horarios, setHorarios] = useState([]);
 const [deshabilitarAgregar, setDeshabilitarAgregar] = useState(true);
 const [departamentosOptions, setdepartamentosOptions] = useState([]);
 const [ciudadOptions, setCiudadOptions] = useState([]);
 const captchaRef = useRef(null)
// const [captchaCargado, setCaptchaCargado] = useState(true);
 const [captchaCargado, setCaptchaCargado] = useState(false)

 const [tipoDocSelected, setTipoDocSelected] = useState("");
 const [open, setOpen] = React.useState(false);
 const [idLogotipo, setIdLogotipo] = useState("");
 
 const tipoInstitucionOptions = [{
  id: 1,
  label: "Pública",
},
{
  id: 2,
  label: "Privada",
}];
 useEffect(() => {
  getServerData();

  
  
}, []);
const getServerData = async () => {
  try {
    const responseDepartamentos = await DnerhsApi.get("/departamentos", {
      params: { pageSize: 100 },
    });
    const responseCiudad = await DnerhsApi.get("/departamentos/1/ciudades", {
      params: { pageSize: 100 },
    });
    
    /*const responseNombreServicioOptions = await DnerhsApi.get("/servicios");
    setNombreServicioOptions(
      responseNombreServicioOptions.data.map((x) => ({
        label: x.nombre,
        id: x.id,
      }))
    );*/
    
    setdepartamentosOptions(
      responseDepartamentos.data.map((x) => ({
        label: x.descripcion,
        id: x.id,
      }))
    );
    setCiudadOptions(
      responseCiudad.data.map((x) => ({
        label: x.descripcion,
        id: x.id,
      }))
    );

  } catch (error) {
    console.log(error);
    if (error.response) {
      showServerError(error);
    } else {
      showMessageError(error);
    }
  }
};
const showServerError = (error) => {
  let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
  if (error.response) {
    message = ResponseUtils.getMessageError(error.response);
  }

  Alert.show({
    message,
    type: "error"
  })
}

const showMessageError = (message) => {
  Alert.show({
    message,
    type: "error"
  })
}
  const converToLocalTime = (str)  => {
   var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
    console.log(new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0]+' UTC').toISOString());
    return (new Date(new Date([date.getFullYear(), mnth, day].join("-")).toString().split('GMT')[0]+' UTC').toISOString());
  }

  const onSubmit = async (data) => {  
    data.fechaNacAux=props.fechaNacAux;   
      let dataCopy = { ...data };    
   /*   dataCopy.captchaCargado=captchaCargado; */
      dataCopy.captchaCargado=false;
      props.onSave(dataCopy);
  }
  const onChangeSolicitud = (e, itemx) => {
    if(e!=null){
    let listCopy = [];
    setHorarios(listCopy);   
    reset2();  
    setDeshabilitarAgregar(false);
    setTimeDesde("00:00");
    setTimeHasta("00:00");
      reset2();
    }else{
      setDeshabilitarAgregar(true);

    }
  };

  const handleClose = () => {
    props.onClose();
  };
  
  const handleCloseUpdate = (value) => {
    setOpen(false);
    console.log('value------------------')
    console.log(value)
    console.log('value------------------')
    setValue('logotipo',value);
    setIdLogotipo(value);
  };

  const getOptionLabelEstudiantes = (convenio) => {
    return  `${convenio.estudiante?.cedulaIdentidad} - ${convenio?.estudiante?.nombres} ${convenio?.estudiante?.apellidos}`;
  }

  const getOptionLabelTutores = (convenio) => {
    return  `${convenio.tutor?.cedulaIdentidad} - ${convenio?.tutor?.nombres} ${convenio?.tutor?.apellidos}`;
  }

  const getOptionLabelEstablecimientos = (solicitud) => {
    return `${solicitud?.nombreServicio?.nombre}`;
   //return `Nro. de Solicitud: ${solicitud?.id} - Establecimiento: ${solicitud?.datosEstablecimiento?.institucionEstablecimiento?.nombreServicio?.nombre}`;
  }
  const getOptionLabelPlazas = (solicitud) => {
   return `Nro. de Solicitud: ${solicitud?.id} - Establecimiento: ${solicitud?.datosEstablecimiento?.institucionEstablecimiento?.nombreServicio?.nombre}`;
  }
  const onChange = () => {
    console.log("Hubo un cambio");
    console.log(captchaRef.current.getValue());
    if(captchaRef.current.getValue()){
     console.log("El usuario no es un robot!!!");
     setCaptchaCargado(false);
     //downloadFile();
    //abrirCerrarModal2();

     //handleOpenDialog();
    }else{
      setCaptchaCargado(true);
    }
   }
const changeCiudades  = async (e) =>{
  //setTimeDesde(e.target.value)
  const responseCiudad = await DnerhsApi.get(`/departamentos/${e.target.value}/ciudades`, {
    params: { pageSize: 100 },
  });
  setCiudadOptions(
    responseCiudad.data.map((x) => ({
      label: x.descripcion,
      id: x.id,
    }))
    );
  }
  const handleClickOpen = (tipoDoc) => {
    setTipoDocSelected(tipoDoc)
    setOpen(true);
  };
  return (
    <>
      <Dialog fullScreen open={props.open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.onClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Nueva Institución Formadora
            </Typography>
            <Button autoFocus color="inherit" onClick={handleClose}>
              Cerrar
            </Button>
          </Toolbar>
        </AppBar>
        <Box padding={3}>
          <Grid container justifyContent="center">
            <Grid item xs={6}>
              <FormProvider {...methods}>
                <form>
                  <Grid container direction="row">
                    <Grid item xs={12}>
                      <Grid item xs={12} className={classes.field}>
                        <Typography align="center" variant="h6" color="primary">
                        Datos de la Institución Formadora

                        </Typography>
                      </Grid>
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="flex-start"
                      >
                
               

                    <Grid item xs={6} className={classes.form}>
                    
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="institucion"
                          label="Institución"
                          
                          errorobj={errors}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="sede"
                          label="Sede"
                          
                          errorobj={errors}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="telefono"
                          label="Teléfono"
                          
                          errorobj={errors}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="email"
                          label="E-mail"
                          
                          errorobj={errors}
                          required
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" p={2} border={1} borderColor="grey.300" borderRadius={4}>
                          <Box>
                            <Typography variant="body1">
                              Logotipo de la institución
                            </Typography>
                          </Box>
                          <Box>
                            <Tooltip title="Subir" aria-label="subir">
                              <span>
                                <IconButton
                                  size="small"
                                  aria-label="subir"
                                  color="primary"
                                  onClick={() => handleClickOpen('Logotipo de la institución')}
                                >
                                  <CloudUploadIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Box>
                        </Box>
                      </Grid>

                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="logotipo"
                          label="Logotipo"
                          errorobj={errors}
                          inputProps={
                            { readOnly: true }
                          }
                          required
                        />
                      </Grid>

                    </Grid>
                    <Grid item xs={6} className={classes.form}>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          name="direccion"
                          label="Dirección"
                          errorobj={errors}
                          required
                          
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormSelect
                          name="departamento"
                          label="Departamento"
                          options={departamentosOptions}
                          
                          onClick={(e) =>changeCiudades(e)}
                          errorobj={errors}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormSelect
                          name="ciudad"
                          label="Ciudad"
                          options={ciudadOptions}
                          
                          errorobj={errors}
                          required
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                        <FormInput
                          type= "number"
                          name="ley"
                          label="Nº de Ley de Creación"
                          errorobj={errors}
                          required
                          
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.field}>
                      <FormSelect
                        name="tipoInstitucion"
                        label="Pública/Privada"
                        options={tipoInstitucionOptions}
                        errorobj={errors}
                        required
                      />
                    </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignContent="flex-end"
                    >
              {/*
                      <ReCAPTCHA
                         
                         sitekey="6Lefd0kqAAAAAAhIVvfr-woIwH2S0_dDYPxQsDBa"
                       //  sitekey="6LcHohopAAAAAEglVfXf_DUn2hye3GkcbHnl5PA1"
                         onChange={onChange}
                                            />
                                                 */}
                      {
                         
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={handleSubmit(onSubmit)}
                          className={classes.field}
                     /*    disabled={captchaCargado} */
                         disabled={false}
                        >
                          Guardar
                        </Button>
                      }
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
                </form>
              </FormProvider>              
            </Grid>
          </Grid>
          <AdjuntosDialog
            open={open}
            onClose={handleCloseUpdate}
            tipoDoc={tipoDocSelected}
            aria-labelledby="form-dialog-title"
          />
        </Box>
      </Dialog>
    </>
  );
}